import { css } from '@mui/material'
import { useRouter } from 'next/compat/router'
import { useTranslation } from 'next-i18next'
import { useEffect, useState } from 'react'
import FilterIcon from 'assets/icons/nucleo/18px_filter.svg'
import { Option } from 'components/Layout/Header/SearchBar/LocationTabContent'
import { Button, ButtonVariant } from 'components/common/Button'
import { searchClient } from 'containers/meilisearchClient'
import { FRANCE_GEO_SEARCH } from 'domain/constants/FranceGeoCoordinates'

interface FakeFiltersProps {
  parsedTypeOrDistance?: string
  parsedLocation?: string
  sortBy?: string
  distances?: readonly string[]
}

export default function FakeFilters({
  parsedTypeOrDistance,
  distances,
  sortBy,
  parsedLocation
}: FakeFiltersProps) {
  const { t } = useTranslation('home')
  const router = useRouter()
  const [geoSearch, setGeoSearch] = useState<string>()

  const params = {
    ...(parsedTypeOrDistance && { editionLiveLevel2Category: distances }),
    ...(geoSearch && { geoSearch, geoLocation: parsedLocation }),
    ...(sortBy && { sortBy })
  }

  useEffect(() => {
    const fetchLocations = async () => {
      const { results } = await searchClient.search<Option>([
        {
          indexName: 'geonames',
          params: {
            query: parsedLocation,
            hitsPerPage: 5,
            filters: '"feature code"="ADM1" OR "feature code"="ADM2"',
            attributesToRetrieve: ['bbox', 'name'],
            attributesToHighlight: []
          }
        }
      ])
      if (
        results[0] &&
        'hits' in results[0] &&
        results[0].hits &&
        results[0].hits.length > 0
      ) {
        const bbox = results[0].hits.find(
          (hit) => hit.name.toLowerCase() === parsedLocation?.toLowerCase()
        )?.bbox
        if (bbox) {
          setGeoSearch([bbox.northEast, bbox.southWest].flat().join())
        }
      } else {
        // Use France as default if location not found
        setGeoSearch(FRANCE_GEO_SEARCH)
      }
    }
    if (parsedLocation) {
      fetchLocations()
    } else {
      // Use France as default if no location is parsed
      setGeoSearch(FRANCE_GEO_SEARCH)
    }
  }, [parsedLocation])

  return (
    <Button
      variant={ButtonVariant.Quaternary}
      label={t('filters.title')}
      leftIcon={
        <FilterIcon
          css={css`
            min-width: 18px;
          `}
        />
      }
      onClick={() =>
        router?.push({
          pathname: '/search',
          query: { ...params, openFilters: true }
        })
      }
    />
  )
}
